"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChildType = getChildType;
exports.getPopulateChild = getPopulateChild;
exports.getPopulateObj = getPopulateObj;
exports.getPopulateObjs = getPopulateObjs;
exports.getPopulates = getPopulates;
exports.populateList = populateList;
exports.promisesForPopulate = promisesForPopulate;

var _some2 = _interopRequireDefault(require("lodash/some"));

var _has2 = _interopRequireDefault(require("lodash/has"));

var _set2 = _interopRequireDefault(require("lodash/set"));

var _forEach2 = _interopRequireDefault(require("lodash/forEach"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _isObject2 = _interopRequireDefault(require("lodash/isObject"));

var _filter2 = _interopRequireDefault(require("lodash/filter"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPopulateObj(str) {
  if (!(0, _index.isString)(str)) {
    return str;
  }

  const strArray = str.split(':');
  return {
    child: strArray[0],
    root: strArray[1]
  };
}

function getChildType(child) {
  if ((0, _index.isString)(child)) {
    return 'string';
  }

  if (Array.isArray(child)) {
    return 'array';
  }

  if ((0, _isObject2.default)(child)) {
    return 'object';
  }

  return 'other';
}

function getPopulateObjs(arr) {
  if (!Array.isArray(arr)) {
    return arr;
  }

  return arr.map(o => (0, _isObject2.default)(o) ? o : getPopulateObj(o));
}

function getPopulates(queryParams) {
  const populates = (0, _filter2.default)(queryParams, param => param.indexOf('populate') !== -1 || (0, _isObject2.default)(param) && param.populates).map(p => p.split('=')[1]);

  if (!populates.length) {
    return null;
  }

  return populates.map(getPopulateObj);
}

function getPopulateChild(firebase, populate, id) {
  const childPath = populate.childParam ? `/${populate.childParam}` : '';
  const path = `${populate.root}/${id}${childPath}`;
  return firebase.database().ref().child(path).once('value').then(snap => snap.val());
}

function populateList(firebase, list, p, results) {
  if (!results[p.root]) {
    (0, _set2.default)(results, p.root, {});
  }

  return Promise.all((0, _map2.default)(list, (id, childKey) => {
    const populateKey = id === true || p.populateByKey ? childKey : id;
    return getPopulateChild(firebase, p, populateKey).then(pc => {
      if (pc) {
        return (0, _set2.default)(results, `${p.root}.${populateKey}`, pc);
      }

      return results;
    });
  }));
}

function promisesForPopulate(firebase, dataKey, originalData, populatesIn) {
  const promisesArray = [];
  const results = {};
  const populatesForData = getPopulateObjs(typeof populatesIn === 'function' ? populatesIn(dataKey, originalData) : populatesIn);
  const dataHasPopulateChilds = (0, _some2.default)(populatesForData, populate => (0, _has2.default)(originalData, populate.child));

  if (dataHasPopulateChilds) {
    (0, _forEach2.default)(populatesForData, p => {
      if ((0, _index.isString)((0, _get2.default)(originalData, p.child))) {
        return promisesArray.push(getPopulateChild(firebase, p, (0, _get2.default)(originalData, p.child)).then(v => {
          if (v) {
            (0, _set2.default)(results, `${p.root}.${(0, _get2.default)(originalData, p.child)}`, v);
          }
        }));
      }

      return promisesArray.push(populateList(firebase, (0, _get2.default)(originalData, p.child), p, results));
    });
  } else {
    (0, _forEach2.default)(originalData, (d, key) => {
      const populatesForDataItem = getPopulateObj(typeof populatesIn === 'function' ? populatesIn(key, d) : populatesIn);
      (0, _forEach2.default)(populatesForDataItem, p => {
        const idOrList = (0, _get2.default)(d, p.child);

        if (!idOrList) {
          return;
        }

        if ((0, _index.isString)(idOrList)) {
          return promisesArray.push(getPopulateChild(firebase, p, idOrList).then(v => {
            if (v) {
              (0, _set2.default)(results, `${p.root}.${idOrList}`, v);
            }

            return results;
          }));
        }

        if (Array.isArray(idOrList) || (0, _isObject2.default)(idOrList)) {
          return promisesArray.push(populateList(firebase, idOrList, p, results));
        }
      });
    });
  }

  return Promise.all(promisesArray).then(() => results);
}